export const knownBrokenCCTPLedgerChainIds = [
  "noble-1",
  "evmos_9001-2",
  "dymension_1100-1",
  "injective-1",
  "dimension_37-1",
];

export const knownEthermintLedgerChainIds = ["evmos_9001-2", "dymension_1100-1", "injective-1", "dimension_37-1"];
